import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, BACKEND } from "@/lib/api";
import { play } from "@/lib/sound";

export function useTable(id, meId) {
  const [st, setSt] = useState(null);
  const [left, setLeft] = useState(null);
  const ver = useRef(0);
  const prevTurn = useRef(null);
  const wsRef = useRef(null);

  const apply = useCallback((s) => {
    if (!s || s.version < ver.current) return;
    ver.current = s.version;
    (s.sounds || []).forEach(play);
    if (s.turn === meId && prevTurn.current !== meId) play("turn");
    prevTurn.current = s.turn;
    setSt(s);
    setLeft(s.turn_left);
  }, [meId]);

  useEffect(() => {
    let alive = true, ws, poll;
    const connect = () => {
      try {
        ws = new WebSocket(`${BACKEND.replace(/^http/, "ws")}/api/games/ws/${id}?token=${localStorage.getItem("token")}`);
        wsRef.current = ws;
        ws.onmessage = (e) => apply(JSON.parse(e.data));
        ws.onclose = () => { if (alive) setTimeout(connect, 2000); };
      } catch { /* polling handles it */ }
    };
    connect();
    poll = setInterval(() => api.get(`/games/tables/${id}`).then((r) => apply(r.data)).catch(() => {}), 2500);
    api.get(`/games/tables/${id}`).then((r) => apply(r.data)).catch((e) => toast.error(errMsg(e)));
    return () => { alive = false; clearInterval(poll); ws?.close(); };
  }, [id, apply]);

  useEffect(() => {
    if (left == null) return;
    const t = setInterval(() => setLeft((l) => { const n = Math.max(0, (l ?? 0) - 1); if (n <= 3 && n > 0 && st?.turn === meId) play("tick"); return n; }), 1000);
    return () => clearInterval(t);
  }, [left == null, st?.turn, meId]);

  const act = useCallback(async (path, body = {}) => {
    try { const { data } = await api.post(`/games/tables/${id}/${path}`, body); if (data?.version) apply(data); return data; } catch (e) { toast.error(errMsg(e)); throw e; }
  }, [id, apply]);

  return { st, left, act };
}
